import { localeIgnoreCaseEquals } from 'common/utilities/String';
import { Platform } from 'mcsclient/models';

export function isWindows(platform: Platform | undefined) {
  return localeIgnoreCaseEquals(platform, 'Windows');
}

export function isAndroid(platform: Platform | undefined) {
  return localeIgnoreCaseEquals(platform, 'Android');
}

export function isIOS(platform: Platform | undefined) {
  return localeIgnoreCaseEquals(platform, 'IOS');
}

export function isMacOS(platform: Platform | undefined) {
  return localeIgnoreCaseEquals(platform, 'MacOS');
}

export function isMacOSOrIOS(platform: Platform | undefined) {
  return isMacOS(platform) || isIOS(platform);
}

export function isMobilePlatform(platform: Platform | undefined) {
  return isAndroid(platform) || isIOS(platform);
}
